import http from "./http";

export interface InternalUserSidenavAssignment {
  id?: number | string;
  sidenav_item?: {
    id?: number | string;
  } | null;
}

export const getInternalUserSidenavItems = async (
  userId: string | number
): Promise<InternalUserSidenavAssignment[]> => {
  const response = await http.get(`/api/internal-user-sidenav-items/${userId}`);
  return Array.isArray(response.data) ? response.data : [];
};

export const saveInternalUserSidenavItems = async (
  userId: string | number,
  sidenavItemIds: (string | number)[]
) => {
  return http.post("/api/internal-user-sidenav-items", {
    user_id: userId,
    sidenav_item_ids: sidenavItemIds,
  });
};
